export default {
    en: {
        title: "Currency Rate",
        rate: "Custom Rate",
        date: "Date",
        usd: "USD",
        uzs: "UZS",
        btn: "Save"
    },
    uz: {
        title: "Valyuta kursi",
        rate: "Maxsus narx",
        date: "Sana",
        usd: "USD",
        uzs: "UZS",
        btn: "Saqlash"
    },
    ru: {
        title: "Курс валюты",
        rate: "Пользовательский тариф",
        date: "Дата",
        usd: "USD",
        uzs: "UZS",
        btn: "Сохранить"
    },
}